import axios from 'axios';
import toast from 'react-hot-toast';
import { getImageUrlPlant } from '@/features/plants/hooks/queries/[plantId]/get-image-url.ts';
import { compressImage } from '@/features/plants/utils/compress-image.ts';

export const uploadImages = async (
  images: unknown,
  plantId: string,
  signal?: AbortSignal
): Promise<void> => {
  if (!Array.isArray(images) || images.length === 0) return;

  const uploadPromises = images
    .filter((image): image is File => image instanceof File)
    .map(async (image) => {
      try {
        const compressedImage = await compressImage(image, signal);

        // eslint-disable-next-line no-console
        console.log('Image successfully compressed');

        const response = await getImageUrlPlant({
          id: plantId,
          file: compressedImage,
          signal,
        });

        // eslint-disable-next-line no-console
        console.log('Sign URL successfully response');

        if (response?.uploadUrl) {
          await axios.put(response.uploadUrl, compressedImage, {
            headers: { 'Content-Type': compressedImage.type },
            signal,
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error uploading plant image', error);
        toast.error(`Failed to upload plant image.`);
      }
    });

  await Promise.allSettled(uploadPromises);
};
